export interface OperationsSystemSnapshot {
  health: unknown;
  performance: unknown;
  version: string;
  commit: string;
  buildTime?: string;
}

/** Share only an in-flight Operations read; later refreshes recheck the session and server. */
export function createSystemSnapshotReader(request: (url: string) => Promise<OperationsSystemSnapshot>) {
  let pending: Promise<OperationsSystemSnapshot> | null = null;
  return () => {
    if (!pending) {
      pending = Promise.resolve()
        .then(() => request('/api/v1/administration/system'))
        .finally(() => { pending = null; });
    }
    return pending;
  };
}
